import './index.css'
import Button from '../button';
import htmlDocx from 'html-docx-js/dist/html-docx';
import { useRef } from 'react';
import { saveAs } from 'file-saver';
import { useState,useEffect } from 'react';
import { deleteScheduledDate } from '../../functions/deleteScheduledDate';
import IdeaScheduler from '../idea-scheduler';
import { finishPostLive } from '../../functions/finishPost';
import { editIdea } from '../../functions/editIdea';
import { deleteIdea } from '../../functions/deleteIdea';
import { editIdeaApprovalStatus } from '../../functions/editIdeaApproval';
import ImageModule from '../image-module';
import LinkedinPostModule from '../linkedin-post-module';


function ExpandedIdeaItem({renderedFeedItems,setFeedItems,display,title,structure,close,image,id,date,voiceName,isIdeaApproved,setAllItems,linkedinStatus,voiceId,clearImage,linkedinPostUrl: initialLinkedinPostUrl,pending,onGenerationComplete, ideaType}){
    const [displayOfIdeaScheduler,SetDisplayOfIdeaScheduler] = useState('none');
    const [displayOfExpandedIdea,SetDisplayOfExpandedIdea] = useState(null);
    const [displayOfImageModule,SetDisplayOfImageModule] = useState("none");
    const [pendingState,SetPending] = useState(null)
    const [animateButtons, setAnimateButtons] = useState(false);
    const wasPendingRef = useRef(false);
    const [displayOfLinkedinModule,SetDisplayOfLinkedinModule] = useState("none");
    const [approved, setApproved] = useState(!!isIdeaApproved);
    const [renderedVoice,SetRenderedVoice] = useState(null);
    const [copyStatus,SetCopyStatus] = useState("Copy");
    const renderedFeedItemsRef = useRef([]);
    const [currentScheduledDate,setCurrentScheduledDate] = useState(undefined);
    const [liveContent, setLiveContent] = useState(structure);
    const [linkedinPostUrl, setLinkedinPostUrl] = useState(initialLinkedinPostUrl);

    useEffect(() => {
    setApproved(!!isIdeaApproved);
    }, [isIdeaApproved]);

    useEffect(() => {
    SetPending(pending);
    if(!pending) return
    if(pending){
        console.log("pending post");
        setLiveContent("");
        wasPendingRef.current = true;
        finishPostLive(id, SetPending, setLiveContent).then(content => {
            if (content && onGenerationComplete) {
                onGenerationComplete(id, content);
            }
        });
    }
    }, [pending]);

    useEffect(() => {
    if (wasPendingRef.current && !pendingState) {
        setAnimateButtons(true);
        wasPendingRef.current = false;
    }
    }, [pendingState]);

    useEffect(() => {
    setLinkedinPostUrl(initialLinkedinPostUrl);
    }, [initialLinkedinPostUrl]);

    useEffect(() => {
    setLiveContent(structure);
    }, [structure]);

    const toggleApproved = () => {
    setApproved(prev => {
        const next = !prev;
        console.log(renderedFeedItems);
            setAllItems(current =>
            current.map(item =>
                item.id === id
                ? { ...item, approved: next } // or whatever field your item uses
                : item
            )
            );

        editIdeaApprovalStatus(id, next); // ✅ correct value
        console.log("toggling to:", next);

        return next;
    });
    };


    useEffect(() => {
        SetDisplayOfExpandedIdea(display);
        console.log(pending);
        if(display==='block'){
            const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            // Create the new URL with the ID parameter
            const newUrl = `${baseUrl}?id=${(id)}`;
        
            // Use the history API to update the URL
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
    }, [display]);
    
    useEffect(() => {
        renderedFeedItemsRef.current = renderedFeedItems;
      }, [renderedFeedItems]);

        useEffect(() => {
        if (!date) {                 // catches null, "", 0, undefined
            setCurrentScheduledDate(null);
            return;
        }

        const d = new Date(date);
        setCurrentScheduledDate(Number.isNaN(d.getTime()) ? null : d);
        }, [date]);

    
    const handleScheduleClick = () => {
        SetDisplayOfIdeaScheduler("block");
        window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });        
        document.body.style.overflow = "hidden";
    }

    const closeScheduler = () => {
        SetDisplayOfIdeaScheduler("none");
        document.body.style.overflowY = "scroll";
        document.body.style.overflowX = "hidden";
    }

    const handleClose = () => {
        if (pendingState) return;
        SetCopyStatus("Copy");
        SetRenderedVoice(null);
        SetEditObj({text:"Edit",image:"./images/scan.png",enabled:false,function:makeEditable});
        close()
    }

    const copyIdeaToClipBoard = () => {
        let value = document.getElementById("idea-content").innerText;
        navigator.clipboard.writeText(value);
        SetCopyStatus("Copied!");
    }

    const downloadToWord = (id) => { 
        const structure = document.getElementById("idea-content").innerText.replace(/\n/g, "<br>");
        const title = document.getElementsByTagName("h1")[0].innerText;
    
        const content = `
            <html>
                <head>
                    <meta charset="UTF-8">
                    <title>${title}</title>
                </head>
                <body>
                    <h1>${title}</h1>
                    <p style="white-space: pre-wrap;">${structure}</p>
                </body>
            </html>
        `;
    
        const converted = htmlDocx.asBlob(content);
        saveAs(converted, `${title}.docx`);
    };

    const confirmEdits = (id) => {
        let updatedContent = document.getElementById("idea-content").innerText;
        updatedContent = updatedContent.replace(/\n{2,}/g, '\n\n');
        const newState = renderedFeedItemsRef.current.map(item =>
            item.id === id 
                ? { ...item, content: updatedContent }
                : item
        );
        setFeedItems(newState);
        setLiveContent(updatedContent);
        SetEditObj({text:"Edit",image:"./images/scan.png",enabled:false,function:makeEditable});
        editIdea(id,updatedContent);
    }

    const makeEditable = (id) => {
        SetEditObj({text:"Confirm",image:"./images/scan.png",enabled:true,function:confirmEdits})
    }

    
    const confirmDeletion = () =>{
        SetDeleteObj({text:"Sure?",function : deleteThisIdea})
    }

    const [deleteObj,SetDeleteObj] = useState({text : "Delete", function:confirmDeletion});


    const deleteThisIdea = async(id) =>{
        await deleteIdea(id);
        window.location.href = "/ideas";
    }

    const openImageModule = async(id) =>{
        SetDisplayOfImageModule("flex");
        window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });
                document.body.style.overflow = "hidden";        
    }

        const closeImageModule = async(id) =>{
        SetDisplayOfImageModule("none");
        window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });        
        document.body.style.overflow = "";
    }

    const removeScheduledDate = async () => {
    console.log(id);
    await deleteScheduledDate(id);

    setAllItems(current =>
        current.map(item =>
        item.id === id
            ? { ...item, scheduledDate: null }
            : item
        )
    );
    setCurrentScheduledDate(null);
    };

    const handleLinkedinPostSuccess = (url) => {
        setLinkedinPostUrl(url);
        setAllItems(current =>
            current.map(item =>
                item.id === id
                    ? { ...item, posted: true, linkedinPostUrl: url }
                    : item
            )
        );
    };

    const [editObj,SetEditObj] = useState({text:"Edit",image:"./images/scan.png",enabled:false,function:makeEditable});

    return <><div className='expanded-idea' style={{display:displayOfExpandedIdea}}>
    <div className='expanded-idea-header'>
    <h1 className='big-text'>{title}</h1>
    <button className="close close-btn" id="desktop-close" onClick={handleClose} aria-label="Close" style={{opacity: pendingState ? 0.3 : 1, cursor: pendingState ? 'default' : 'pointer'}}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
    </button>
    </div>
    <div className='info-holder-expanded'>
    {!pendingState && <div className={`export-holder${animateButtons ? ' export-holder-enter' : ''}`}>
        <Button image='./images/download_word.png' text='Download' smallBool={false} addedFunction={downloadToWord} params={id}/>
        <Button image='./images/schedule.png' text='Schedule' smallBool={false} addedFunction={handleScheduleClick} params={id}/>
        <Button image='./images/copy.png' text={copyStatus} smallBool={false} addedFunction={copyIdeaToClipBoard} params={id}/>
        <Button image={editObj.image} text={editObj.text} smallBool={false} addedFunction={editObj.function} params={id}/>
        <Button image='./images/image.png' text="Image" smallBool={false} addedFunction={openImageModule} params={id}/>
        <Button image='./images/white-bin.png' text={deleteObj.text} smallBool={false} addedFunction={deleteObj.function} params={id}/>
        {linkedinStatus === "connected" && (
            <Button image='./images/linkedin.png' text='Preview and post' smallBool={false} addedFunction={() => {
                const current = document.getElementById("idea-content")?.innerText;
                if (current) setLiveContent(current);
                SetDisplayOfLinkedinModule("flex");
                window.scrollTo({ top: 0, left: 0 });
                document.body.style.overflow = "hidden";
            }} />
        )}
        {linkedinPostUrl && (
            <a href={linkedinPostUrl} target="_blank" rel="noreferrer" className="view-on-linkedin-btn">
                <Button image='./images/linkedin.png' text='View on LinkedIn' smallBool={false} />
            </a>
        )}
    </div>}
    {!pendingState && <div className={`export-holder${animateButtons ? ' export-holder-enter' : ''}`} id='extra-info-holder'>
    <div style={{display : currentScheduledDate ? 'flex' : 'none'}} className='scheduled-date-expanded'>
        <img className='extra-info-image' src='./images/calendar.png'></img>
        <div className='value-date small-text'>{new Date(currentScheduledDate).toDateString()}</div>
        <button className="remove-date close-btn" onClick={removeScheduledDate} aria-label="Remove date">
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
        </button>
    </div>
    <div style={{display:voiceName ? "flex" : "none"}} className='scheduled-date-expanded'>
        <img className='extra-info-image' src='./images/team.png'></img>
        <div className='value-date small-text'>{voiceName || ""}</div>
    </div>
    <label>
    <input
        className="cb cb2"
        type="checkbox"
        name="work"
        checked={approved}
        onChange={toggleApproved}
    />
    <i></i>
    <span className="approval-label">
        {approved ? "Approved" : "Not approved"}
    </span>
    </label>
    <button className="close close-btn" id="mobile-close" onClick={handleClose} aria-label="Close" style={{opacity: pendingState ? 0.3 : 1, cursor: pendingState ? 'default' : 'pointer'}}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
    </button>
    </div>}
    </div>
    <p id='idea-content' style={{border: editObj.enabled ? "2px solid #0AFB60" : "none"}} contentEditable={editObj.enabled}>{liveContent ? liveContent.replace(/\*/g,"") : ""}</p>
    </div>
    <IdeaScheduler close={closeScheduler} display={displayOfIdeaScheduler} id={id} linkedinStatus={linkedinStatus} />
    <ImageModule display={displayOfImageModule} functionForButton={closeImageModule} image={image} id={id} onDeleteImage={() => clearImage(id)} allowAiCreate={ideaType !== "post"} />
    <LinkedinPostModule
        display={displayOfLinkedinModule}
        close={() => {
            SetDisplayOfLinkedinModule("none");
            document.body.style.overflow = "";
        }}
        structure={liveContent}
        image={image}
        id={id}
        voiceId={voiceId}
        voiceName={voiceName}
        onPostSuccess={handleLinkedinPostSuccess}
    />
    </>
}

export default ExpandedIdeaItem